import React from 'react';

import {
  GATE_IO_LINK,
  KUCOIN_LINK,
  YONDER_LINK,
} from 'src/components/pages/PartnersPage/constants';

import styles from './PartnersSlider.scss';

export const TextNodes = [
  {
    textNode: (
      <>
        <p className={styles.title}>KuCoin</p>
        <p className={styles.subTitle}>
          Travel portal with cashback rewards launched in 1.5 months
        </p>
      </>
    ),
    linkNode: (
      <a className={styles.externalLink} target="_blank" href={KUCOIN_LINK}>
        Explore kucoin.solartrip.com ↗
      </a>
    ),
  },
  {
    textNode: (
      <>
        <p className={styles.title}>Yonder</p>
        <p className={styles.subTitle}>Stays with rewards launched in 1.5 months</p>
      </>
    ),
    linkNode: (
      <a className={styles.externalLink} target="_blank" href={YONDER_LINK}>
        Explore yonder.solartrip.com ↗
      </a>
    ),
  },
  {
    textNode: (
      <>
        <p className={styles.title}>Gate.io</p>
        <p className={styles.subTitle}>
          Travel portal with cashback rewards and payments with crypto via Gate Pay launched in 2
          months
        </p>
      </>
    ),
    linkNode: (
      <a className={styles.externalLink} target="_blank" href={GATE_IO_LINK}>
        Explore gateio.solartrip.com ↗
      </a>
    ),
  },
];
